
interface WeekData {
  id?: number;
  weekNumber?: number;
  sort?: number;
  physicalPercent?: number;
  intensityPercent?: number;
  sportPercent?: number;
  comment?: string;
  annualPlanId?: number;
  weekMacroCycleId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
}

export class Week {
  public static getNonTranslatableFields(): string[] { return ['id', 'weekNumber', 'sort', 'physicalPercent', 'intensityPercent', 'sportPercent', 'comment', 'annualPlanId', 'weekMacroCycleId', 'createDate', 'createrId', 'updateDate', 'updaterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'weekNumber', 'sort', 'physicalPercent', 'intensityPercent', 'sportPercent', 'comment', 'annualPlanId', 'weekMacroCycleId', 'createDate', 'createrId', 'updateDate', 'updaterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  weekNumber?: number;
  sort?: number;
  physicalPercent?: number;
  intensityPercent?: number;
  sportPercent?: number;
  comment?: string;
  annualPlanId?: number;
  weekMacroCycleId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;

  public static fromAPI(data: WeekData): Week {
    return new Week(data);
  }

  public static fromAPIList(data: WeekData[]): Week[] {
    return data.map((item: WeekData) => Week.fromAPI(item));
  }

  constructor({id, weekNumber, sort, physicalPercent, intensityPercent, sportPercent, comment, annualPlanId, weekMacroCycleId, createDate, createrId, updateDate, updaterId} : WeekData) {
    this.id = id;
    this.weekNumber = weekNumber;
    this.sort = sort;
    this.physicalPercent = physicalPercent;
    this.intensityPercent = intensityPercent;
    this.sportPercent = sportPercent;
    this.comment = comment;
    this.annualPlanId = annualPlanId;
    this.weekMacroCycleId = weekMacroCycleId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
  }


  public toJson(): WeekData {
    return {
      id: this.id,
      weekNumber: this.weekNumber,
      sort: this.sort,
      physicalPercent: this.physicalPercent,
      intensityPercent: this.intensityPercent,
      sportPercent: this.sportPercent,
      comment: this.comment,
      annualPlanId: this.annualPlanId,
      weekMacroCycleId: this.weekMacroCycleId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId
    };
  }
}
